const TOKEN_KEY = "authToken";
const USER_KEY = "authUser";

const tokenService = {
  setToken(token) {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token)
    } 
    else {
      this.removeToken(); 
    }
   },

  getToken() {
      return localStorage.getItem(TOKEN_KEY)
    },

  removeToken() {
    localStorage.removeItem(TOKEN_KEY);
  },
  setUserDetails(user) {
    if (user) {
      localStorage.setItem(USER_KEY, JSON.stringify(user));
    } else {
      this.removeUserDetails();
    }
  },

  getUserDetails() {
        const user = localStorage.getItem(USER_KEY)
        return user ? JSON.parse(user) : null;
  },

  getUserId() {
    const user = this.getUserDetails();
    return user?._id || user?.id || null;
  },

  removeUserDetails() {
    localStorage.removeItem(USER_KEY);
  },
  removeOnboardingStatus() {
    localStorage.removeItem("onboardingCompleted");
  },

  clearAll() {
    localStorage.clear();
  },
};

export default tokenService;
